module.exports = __webpack_public_path__ + "fonts/Calibre-RegularItalic.35657aa2.woff2";